export const combineUniqueUrlSearchParams = (
  ...paramsArray: URLSearchParams[]
): URLSearchParams => {
  const combinedParams = new URLSearchParams();

  paramsArray.forEach((params) => {
    params.forEach((value, key) => {
      combinedParams.append(key, value);
    });
  });

  return combinedParams;
};
